import { gaClickAttrs } from "@booking/utils/tracking";
import clsx from "clsx";

import { type CommonProps } from "@/types";
import { createId } from "@/utils/helpers";

import styles from "./RegionFacet.module.css";

const ref = "region-facet";

interface RegionFacetProps extends Partial<CommonProps> {
  count: number | null;
  label: string;
  onClick: () => void;
}

function useRegionFacet(props: RegionFacetProps) {
  const { id = createId(ref) } = props;
  const className = clsx(styles[ref], props.className);

  return {
    className,
    id,
  };
}

function RegionFacet(props: RegionFacetProps) {
  const { className, id } = useRegionFacet(props);
  const { count } = props;

  return (
    <div className={className} id={id}>
      <div
        className={styles.label}
        onClick={props.onClick}
        {...gaClickAttrs({
          eventGroup: "Filters",
          click: "region_click",
          clickTarget: props.label,
        })}
      >
        {props.label}
        {count && <span className={styles.count}>({count})</span>}
      </div>
    </div>
  );
}

export default RegionFacet;
export { RegionFacet, type RegionFacetProps };
